import SERVICE_URL from "../config/API_DATA"
import BaseConfiguration from "../config/base.js"
import HttpPost from "../http/httppost.js";
import Logger from './logger.js';

import {
    LOG_TYPE,
    FILE_NAME
} from "../config/API_DATA";
export default class SystemReport {
    static buildRequest(pFromDate,pToDate,pB2bId) {
        if (BaseConfiguration.isDebug) console.log("buildRequest");

        let returnValue = null;

        try {
           
            let body = {  
                    "fromDate":pFromDate,
                    "toDate":pToDate,
                    "b2bid":pB2bId
            };

            returnValue = body;
        } catch (err) {
            let body = Logger.buildRequest(FILE_NAME.API_GET_TOPUP_REPORT, "error in building body for system report api", err.toString(), "buildRequest", LOG_TYPE.ERROR);
            Logger.getResponse(body);
        }
        return returnValue;
    }

    static async getResponse(pReqOptions) {
        if (BaseConfiguration.isDebug) console.log("getResponse");


        let returnValue = null;
        try {

            returnValue = await HttpPost.makeHttpPostRequest(SERVICE_URL.API_GET_TOPUP_REPORT, pReqOptions);

        } catch (err) {

            let body = Logger.buildRequest(FILE_NAME.API_GET_TOPUP_REPORT, "error in getting Response from system report api ", err.toString(), "getResponse", LOG_TYPE.ERROR);
            Logger.getResponse(body);
        }
        // console.log(returnValue);
        return returnValue;

    }


}